exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Projects-module__wrapper___1j22d{display:grid;grid-template-columns:1fr;gap:1.5rem}@media screen and (min-width:525px){.Projects-module__wrapper___1j22d{grid-template-columns:repeat(auto-fill,minmax(400px,1fr))}}", ""]);

// exports
exports.locals = {
	"wrapper": "Projects-module__wrapper___1j22d"
};